package ar.corzo.firebase.npm

import ar.corzo.health_tracker.utils.parseNativeToJson
import org.khronos.webgl.ArrayBuffer
import org.khronos.webgl.Int8Array
import org.khronos.webgl.get

fun mapOf(container: dynamic): Map<Any?, Any?>? {
    val entries = js("Object.entries")(container) as? Array<Array<Any>>
    return entries?.associate {
        val (k, v) = it.toList().take(2)
        k to v
    }
}

fun json(vararg pairs: Pair<String, Any?>): dynamic{
    return json(pairs.toList())
}
fun json(pairs: List<Pair<String, Any?>>): dynamic{
    return JSON.parse(pairs.toMap().parseNativeToJson().toString())
}
fun Map<String, Any?>.toJs(): dynamic{
    return JSON.parse(parseNativeToJson().toString())
}

const val firebaseApiKey = "AIzaSyBZDsYGU_J8wYhdfnjzs_tRGQSFnwnBT_o"
val firebaseClientInitConfig = json(
    "apiKey" to firebaseApiKey,
    "authDomain" to "training-manager-b1b35.firebaseapp.com",
    "projectId" to "training-manager-b1b35",
    "storageBucket" to "training-manager-b1b35.firebasestorage.app",
    "messagingSenderId" to "128515194935",
    "appId" to "1:128515194935:web:0509b3a3bd28d04b0fffb2"
)
fun initApp() {
    if (getApps().isEmpty()) initializeApp(firebaseClientInitConfig)
}
private fun app() = if (getApps().isNotEmpty()) getApp() else initializeApp(firebaseClientInitConfig)
fun storage() = getStorage(app())
fun auth() = getAuth(app())
fun firestore() = getFirestore(app())


fun ArrayBuffer.toBytes(): ByteArray {
    val arr = Int8Array(this)
    val result = ByteArray(arr.length)
    for (i in 0..<arr.length) {
        result[i] = arr[i]
    }
    return result
}